module.exports = __webpack_public_path__ + "img/logo_sante-300x80.2abe2a63.png";